import React, { useState } from 'react';
import styles from './WorldCupSquad.module.css';
import { getFlagUrl } from '../../../server/services/custom-pages/worldcupFlags';
import { getApiHost } from '../../../server/services/custom-pages/apiHost';
import OptimizedImage from '../player/OptimizedImage';

export default function WorldCupSquad({ teams = [], squads = {}, photoMap = {} }) {
    // Teams arrive pre-sorted from the server; default to the first team.
    const [selectedTeamId, setSelectedTeamId] = useState(teams[0]?.id ?? null);

    if (!teams || teams.length === 0) {
        return (
            <section className={styles.squadSectionWrapper}>
                <h2 className={styles.squadHeading}>Squad List</h2>
                <div className={styles.squadStatusMsg}>Squad list is currently unavailable.</div>
            </section>
        );
    }

    // All squads are prefetched, so switching teams is instant (no fetch).
    const squad = squads[selectedTeamId] || [];

    return (
        <section className={styles.squadSectionWrapper}>
            <h2 className={styles.squadHeading}>Squad List</h2>

            {/* Nations selector row */}
            <div className={styles.tabsContainer}>
                {teams.map(team => (
                    <button
                        key={team.id}
                        onClick={() => setSelectedTeamId(team.id)}
                        className={`${styles.tabBtn} ${selectedTeamId === team.id ? styles.tabBtnActive : ''}`}
                    >
                        {getFlagUrl(team.name) && (
                            <img
                                src={getFlagUrl(team.name)}
                                alt={team.name}
                                className={styles.squadTeamFlagImg}
                            />
                        )}
                        <span>{team.name}</span>
                    </button>
                ))}
            </div>

            {/* Players cards slider */}
            <div className={styles.playersScroll}>
                {squad.length === 0 ? (
                    <div className={styles.emptyMsg}>
                        No players listed in squad yet.
                    </div>
                ) : (
                    squad.map((player) => {
                        // Render statscore player image if available
                        const photoUrl = photoMap[String(player.id)] || `${getApiHost()}/player/fallback.png`;

                        return (
                            <div key={player.id} className={styles.playerCard}>
                                <div className={styles.photoWrapper}>
                                    <OptimizedImage
                                        src={photoUrl}
                                        alt={player.name}
                                        width={120}
                                        height={120}
                                        unoptimized
                                        className={styles.playerPhoto}
                                    />
                                </div>
                                <h4 className={styles.playerName}>{player.short_name || player.name}</h4>
                                <span className={styles.playerPosition}>
                                    {player.details?.position_name}
                                </span>
                            </div>
                        );
                    })
                )}
            </div>
        </section>
    );
}
